<template>
  <div :class="['inlineBlockButton', {flexButton: isFlex}]">
    <div
      v-if="badge"
      class="badge"
      @click="processarClique">
      {{ badge }}
    </div>
    <a
      v-if="setURL"
      v-bind="$attrs"
      :class="[getButtonClass, deepClass,
              {'botao-primario-blog--disabled': disabled},
              {'botao-primario-blog--loading': loading}]"
      :style="customStyle"
      :href="setURL"
      class="botao-primario-blog"
      @click="processarClique">
      {{ loading ? '' : texto }}
    </a>
    <button
      v-if="!setURL"
      v-bind="$attrs"
      :class=" [deepClass,
               {'botao-primario-blog--disabled': disabled},
               {'botao-primario-blog--loading': loading}]"
      :disabled="disabled"
      :style="customStyle"
      class="botao-primario-blog"
      @click="processarClique">
      {{ loading ? '' : texto }}
      <span v-if="iconePlay">
        <img
          src="@/assets/icons/play-circle.svg"
          alt="play"
          aria-disabled="true">
      </span>

      <slot
        v-if="!loading"
        name="icon" />
    </button>
  </div>
</template>

<script>

export default {
  name: 'BotaoPrimario',
  inheritAttrs: false,
  props: {
    modifier: {
      type: String,
      default: '',
      required: false
    },
    texto: {
      type: String,
      required: true
    },
    tema: {
      type: [String, Function],
      default: 'dark-blue-filled-theme'
    },
    onClick: {
      type: Function,
      default: ()=>{ return; }
    },
    callBack: {
      type: Function,
      default: ()=>{ return; }
    },
    isFlex: {
      type: Boolean,
      default: true
    },
    badge: {
      type: String,
      default: ''
    },
    tamanho: {
      type: String,
      default: 'medium'
    },
    deepClass: {
      type: String,
      default: ''
    },
    naoTrackearEvento: {
      type: Boolean,
      default: false,
    },
    customStyle: {
      type: String,
      default: ''
    },
    isCircle: {
      type: Boolean,
      default: false
    },
    url: {
      type: [String, Function],
      default: null
    },
    iconePlay: {
      type: Boolean,
      default: false
    },
    localizacao: {
      type: String,
      default: '',
    },
    dadosRastreio: {
      type: Object,
    },
    trackData: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  inject: {
    nomeArea: {
      default: ''
    },
    sectionTracking: {
      default: ''
    },
  },
  computed: {

    setURL() {
      return typeof this.url === 'function' ? this.url() : this.url;
    },

  },
  methods: {
    normalizeText(text) {
      return (text || '').normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replaceAll(' ','-')
      .replaceAll('/','e')
      .toLowerCase();
    },

    processarClique: function (event) {
      this.$emit('click', event)

      if (!this.url && this.onClick && typeof this.onClick === 'function') {
        this.onClick(event, this.nomeArea)
      }

      if (typeof this.callBack === 'function') {
        this.callBack()
      }
    },
  }
}
</script>

<style lang="scss" scoped>
$light-neutral: #d0ddea;
$medium-neutral: #7c92ab;
$light-blue: #04f7f7;
$dark-dark-blue: #002868;
.botao-primario-blog {
  height: 55px;
  border-radius: 4px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
  font-weight: 500;
  letter-spacing: 1px;
  text-transform: uppercase;
  text-decoration: none;
  border: 0!important;
  font-size: 16px;
  padding: 0 25px;


  &:focus {
    outline: none;
  }

  &--disabled {
    background-color: $light-neutral !important;
    border: $light-neutral;
    color: $medium-neutral !important;
    pointer-events: none;
    cursor: not-allowed;
  }

  &--loading::after {
    content: "";
    position: absolute;
    width: 16px;
    height: 16px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border: 4px solid transparent;
    border-top-color: #ffffff;
    border-radius: 50%;
    animation: button-loading-spinner 1s ease infinite;
  }

  @keyframes button-loading-spinner {
    from {
      transform: rotate(0turn);
    }

    to {
      transform: rotate(1turn);
    }
  }
}

.blue-light {
  background-color: $light-blue;
  color: $dark-dark-blue;
}

.blue-normal {
  background-color: #1F6FF0;;
  color: #fff;
}
</style>
